import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

function getSessionId() {
  let sid = localStorage.getItem("srm_session");
  if (!sid) {
    sid = (window.crypto && crypto.randomUUID)
      ? crypto.randomUUID()
      : String(Date.now()) + Math.random().toString(16).slice(2);
    localStorage.setItem("srm_session", sid);
  }
  return sid;
}

// Records a page view on every route change and a lightweight heartbeat every 15s
// so the founder dashboard can show live online users and traffic trends.
export default function TrafficTracker() {
  const location = useLocation();
  const sid = useRef(getSessionId());

  useEffect(() => {
    api.post("/track", { session_id: sid.current, path: location.pathname, type: "pageview" }).catch(() => {});
  }, [location.pathname]);

  useEffect(() => {
    const ping = () => api.post("/track", { session_id: sid.current, type: "ping" }).catch(() => {});
    const t = setInterval(ping, 15000);
    return () => clearInterval(t);
  }, []);

  return null;
}
